import React from 'react'
import Xligo from '../Classes/Connection'
import ConvertString from '../Classes/ConvertString'
import RenderStyles from '../Components/RenderStyles'
import RenderItems from '../Components/RenderItems'
import LawsReader from '../Components/LawsReader'
import MenuLeft from '../Components/MenuLeft'
import {Preloader, Loading} from '../Components/Libro/Index'
import TOKEN from '../Classes/Costant'


export default class Libro extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            styles: null,
            content: [],
            page:0,
            fromPage: false,
            toPage: false,
            load: false,
            indice: null,

            view: null,
            body: null,

            preview: false,
            preloader: true,
            loader: false,

            loadmore: false,

            resetScale: 1,
            e: null,
            maxPage: 1000,
            batch: false,
            size: 10,
            type: this.props.match.params.type === 'x' ? 'libro' : this.props.match.params.type
        }

    }

    checkToken = () => {
        if( TOKEN.approfondimenti === this.props.match.params.token )
        {
            return true;
        }

        return false;
    }

    getStyles = async () => {
        await Xligo.get(`${this.state.type}/${this.props.match.params.id}/styles`)
        .then(response => response.json())
        .then(data => {
            this.setState({
                styles:data
            }, () => this.getLibroFirstCall())
        })
        .catch(error => console.log(error))
    }

    getLibro = async () => {        
        await Xligo.get(`${this.state.type}/${this.props.match.params.id}/pagine?page=${this.state.page}&size=${this.state.size}${this.__appendUrl()}`)
        .then(response => response.json())
        .then(data => {
            this.setState({
                items: data,
                load: false,
                loader: false
            }, () => this.__handleItems())
        })
        .catch(error => console.log(error))
    }

    __appendUrl = () => {
        let append = "";
        if( this.state.fromPage && !this.state.toPage )
        {
            append = `&fromPage=${this.state.fromPage}`
        }
        return append
    }

    getLibroFirstCall = async () => {

        let url = `${this.state.type}/${this.props.match.params.id}/pagine?`;
        if( this.state.fromPage ) {
            url = `${url}fromPage=${this.state.fromPage}`
        }
        if( this.state.fromPage && this.state.toPage ){
            url = `${url}&toPage=${this.state.toPage}`
        }
        if( this.state.fromPage && !this.state.toPage ){
            url = `${url}&page=${this.state.page}&size=${this.state.size}`
        }
        if( !this.state.fromPage && !this.state.toPage ){
            url = `${url}page=${this.state.page}&size=${this.state.size}`
        }
        
        const response = await Xligo.get(`${url}`)
        const maxResults = response.headers.get("x-total-count")

        const maxPage = Math.ceil(maxResults / this.state.size) -1

        const data = await response.json();
        this.setState({
            items: data,
            load: false,
            loader: false,
            maxPage: maxPage
        }, () => this.__handleItemsFirstCall())
    }
    
    getRiferimento = async (body) => {
        await Xligo.post(`xligo/riferimento`, body)
        .then(response => response.json())
        .then(data => {
            this.setState({
                view: data.content
            })
        })
        .catch(error => console.log(error))
    }

    __handleScroll = (e) => {
        if( this.state.fromPage && this.state.toPage )
        {
            return false;
        }
        const element = document.getElementById("Items")
           
        if(window.innerHeight + e.target.scrollTop > element.offsetHeight && this.state.load === false )
        {
            this.setState({
                page: this.state.page + 1,
                load: true,
                loader: true
            }, () => this.getLibro())
        }        
    }

    __handleItems = () => {
        if(this.state.items) {
            let Items = ConvertString.addData(this.state.items)
            
            const content = this.state.content
            content.push(Items)            

            this.setState({
                content: content,
                loading: null,
                preloader: false                
            })
        }
        return null
    }

    __handleItemsFirstCall = () => {
        if(this.state.items) {
            let Items = ConvertString.addData(this.state.items)
            
            const content = this.state.content
            content.push(Items)            

            this.setState({
                content: content,
                loading: null,
                preloader: false                
            }, () => {
                if( this.state.fromPage && this.state.toPage )
                {
                    return;
                }
                this.__batch()
            })
        }
        return null
    }

    __batch = async () => {
        let nextInLoop = this.state.maxPage;
        let stop = false;

        for(let i = 0; i < nextInLoop; i++)
        {
            if( this.state.batch ) return false;

            let page = this.state.page + 1
            this.setState({page:page})
            const response = await Xligo.get(`${this.state.type}/${this.props.match.params.id}/pagine?page=${page}&size=${this.state.size}${this.__appendUrl()}`)
            const data = await response.json()
            this.setState({
                items: data,
                load: false
            }, () => this.__handleItems())
        }
    }

    __asyncLoop = async (nextInLoop) => {
        for(let i = 0; i < nextInLoop; i++)
        {
            let page = this.state.page + 1
            const response = await Xligo.get(`${this.state.type}/${this.props.match.params.id}/pagine?page=${page}&size=${this.state.size}${this.__appendUrl()}`)
            const data = await response.json()
            this.setState({
                items: data,
                load: false,
                page: page
            }, () => this.__handleItems())
        }
    }

    __scrollToCallback = async (target, currentPage, jumpPage ) => {
         if( currentPage >= jumpPage )
         {
            this.setState({loadmore:false, batch:false}, () => {
                document.getElementById(target).scrollIntoView({
                    behavior: 'smooth'
                })
                this.__batch()
            })
             return;
         }
 
         let nextInLoop = jumpPage - currentPage;
 
         await this.__asyncLoop(nextInLoop);
 
         this.setState({loadmore:false, batch:false}, () => {
             document.getElementById(target).scrollIntoView({
                 behavior: 'smooth'
             })
             this.__batch()
         })
    }

    __loopPageScroll = async (e) => {

        let data = e.getAttribute("data-dest-detail");
        let target = e.getAttribute("href");
        target = target.replace("#", "");
        data = data.replace("[", "");
        data = data.replace("]", "");
        data = data.split(",");

        let currentPage, jumpPage;
        currentPage = this.state.page;
        jumpPage = Math.ceil((data[0] / 3) - 1)
        jumpPage = Math.abs(jumpPage);

        this.__scrollToCallback(target, currentPage, jumpPage )
    }

    __loopPageSearch = async(e) => {

        let data = e.getAttribute("data-page");
        let target = "pf" + e.getAttribute("data-id");

        let currentPage, jumpPage;
        currentPage = this.state.page;
        jumpPage = Math.ceil((data / 3) - 1)
        jumpPage = Math.abs(jumpPage);        

        this.__scrollToCallback(target, currentPage, jumpPage )
    }

    __scroll = async (e, callback) => {
        this.setState({loadmore:true, batch: true}, () => {
            callback(e)
        })
    }

    __getValidity = (e) => {
        let body = {
            "reference": this.state.body.reference,
            "startPosition": this.state.body.startPosition,
            "endPosition": this.state.body.endPosition,
            "date" : e.target.textContent
        }

        this.setState({
            view: null
        }, () => this.getRiferimento(body))
    }

    __getReference = (e) => {
        let reference     = e.target.getAttribute("href")
        let startPosition = e.target.getAttribute("data-start")
        let endPosition   = e.target.getAttribute("data-end")

        let body = {
            "reference": reference,
            "startPosition": startPosition,
            "endPosition": endPosition
        }

        this.setState({
            view:null,
            body: body,
            preview: true
        }, () => this.getRiferimento(body))
    }

    handleClickOutside = async (e) => {
        e.preventDefault()
        const elm = this.state.e;
        if( elm )
        {
            elm.classList.remove("search-results__item--selected")
            elm.classList.remove("selected")
        }        

        if( e.target.className === 'd m4' && e.target.tagName.toLowerCase() === 'div')
        {
            if( e.target.parentElement.getAttribute("href").includes("http") === true )
            {
                window.open(
                    e.target.parentElement.getAttribute("href"),
                    '_blank' // <- This is what makes it open in a new window.
                );

                return;
            }

            this.__scroll(e.target.parentElement, this.__loopPageScroll)
        }

        if( e.target.className === 'search-results__text' && e.target.tagName.toLowerCase() === 'div')
        {
            e.target.parentElement.classList.add("search-results__item--selected")

            this.setState({
                resetScale: 1,
                e: e.target.parentElement
            }, () => setTimeout(() => {
                this.__scroll(e.target, this.__loopPageSearch)
            }, 500))
        }
        
        if( e.target.classList.contains('l') )
        {
            /* e.target.classList.add("selected") */
            this.setState({
                resetScale: 1,
                e: e.target
            }, () => setTimeout(() => {
                this.__scroll(e.target, this.__loopPageScroll)
            }, 500))            
        }
        
        if( e.target.tagName.toLowerCase() === 'span' && e.target.className === 'validity-selector' )
        {
            this.__getValidity(e)
        }

        if( e.target.tagName.toLowerCase() === 'a' && e.target.className !== 'l') 
        {
            if( e.target.getAttribute("href").includes("http") === true )
            {
                window.open(
                    e.target.getAttribute("href"),
                    '_blank' // <- This is what makes it open in a new window.
                );

                return;
            }
            
            this.__getReference(e)
        }
    }

    __display = (status) => {
        this.setState({
            view: null,
            body:null,
            preview: status
        })
    }

    __resetScale = (scale) => {
        this.setState({
            resetScale: scale
        })
    }

    __getUrlParams = () => {
        let params = new URLSearchParams(this.props.location.search)
        let fromPage, toPage = false
        if( params.has("fromPage") )
        {
            fromPage = params.get("fromPage")
        }
        if( params.has("toPage") )
        {
            toPage = params.get("toPage")
        }

        this.setState({
            fromPage: fromPage,
            toPage: toPage
        })
    }

    componentDidMount = () => 
    {
        this.__getUrlParams()
        let status = this.checkToken();
        if( status ) {
            this.getStyles()
            document.addEventListener("click",  this.handleClickOutside, true  )
            document.title = `Visualizza ISBN: ${this.props.match.params.id} | e-Book Maggioli`;
        }
    }

    render = () => {
        if( this.state.content.length > 0 ) {
            return (
                <div onScroll={this.__handleScroll}>
                    <MenuLeft /* ref={this.child} */ bookId={this.props.match.params.id} type={this.state.type} dataPage={{
                        fromPage: this.state.fromPage,
                        toPage: this.state.toPage
                    }} resetScale={(scale) => this.__resetScale(scale)} scale={this.state.resetScale} />
                    <RenderStyles styles={this.state.styles} />
                    <LawsReader className={this.state.preview ? 'menu--active' : ''} content={this.state.view} display={() => this.__display(false)} />
                    <div id="page-container">
                        <Loading show={this.state.loader} />
                        <div id="Items" className="book">
                            <RenderItems content={this.state.content} />
                        </div>
                    </div>
                    <Preloader show={this.state.loadmore} />
                </div>
            )
        }
        return (
            <Preloader show={this.state.preloader} />
        )
    }
}
